/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SinglePropertyResponse } from './SinglePropertyResponse';
import {
    SinglePropertyResponseFromJSON,
    SinglePropertyResponseFromJSONTyped,
    SinglePropertyResponseToJSON,
    SinglePropertyResponseToJSONTyped,
} from './SinglePropertyResponse';

/**
 * 
 * @export
 * @interface FindListingsAv8Response
 */
export interface FindListingsAv8Response {
    /**
     * 
     * @type {Array<SinglePropertyResponse>}
     * @memberof FindListingsAv8Response
     */
    items: Array<SinglePropertyResponse>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FindListingsAv8Response
     */
    meta: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FindListingsAv8Response
     */
    links: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof FindListingsAv8Response
     */
    territoryBestMatch?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof FindListingsAv8Response
     */
    addressMatchingMethod?: string;
}

/**
 * Check if a given object implements the FindListingsAv8Response interface.
 */
export function instanceOfFindListingsAv8Response(value: object): value is FindListingsAv8Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    return true;
}

export function FindListingsAv8ResponseFromJSON(json: any): FindListingsAv8Response {
    return FindListingsAv8ResponseFromJSONTyped(json, false);
}

export function FindListingsAv8ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindListingsAv8Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SinglePropertyResponseFromJSON)),
        'meta': json['meta'],
        'links': json['links'],
        'territoryBestMatch': json['territoryBestMatch'] == null ? undefined : json['territoryBestMatch'],
        'addressMatchingMethod': json['addressMatchingMethod'] == null ? undefined : json['addressMatchingMethod'],
    };
}

export function FindListingsAv8ResponseToJSON(json: any): FindListingsAv8Response {
    return FindListingsAv8ResponseToJSONTyped(json, false);
}

export function FindListingsAv8ResponseToJSONTyped(value?: FindListingsAv8Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(SinglePropertyResponseToJSON)),
        'meta': value['meta'],
        'links': value['links'],
        'territoryBestMatch': value['territoryBestMatch'],
        'addressMatchingMethod': value['addressMatchingMethod'],
    };
}

